import { Pipe, PipeTransform } from '@angular/core';

import { SortDirections } from '../interfaces/common.interface';

@Pipe({
  name: 'sortByDate',
})
export class SortByDatePipe implements PipeTransform {
  transform(
    items :any[],
    property :string,
    direction = SortDirections.DESC,
  ) :any[] {
    return [...items].sort((a :any, b :any) => {
      if (new Date(a[property]) > new Date(b[property])) {
        return direction === SortDirections.DESC ? 1 : -1;
      }
      if (new Date(a[property]) < new Date(b[property])) {
        return direction === SortDirections.DESC ? -1 : 1;
      }

      return 0;
    });
  }
}
